export const PXPipeTable = (function () {
	'use strict';

	function init() {

		const $input = document.querySelector('[data-pipe-table-input]')
		const $table = document.querySelector('[data-pipe-table]')
		if (!$input || !$table) {
			return
		}
		const $tbody = $table.querySelector('tbody')
		const $rows = $tbody.querySelectorAll('tr')
		const rowData = []

		$rows.forEach(($tr) => {
			const fields = []
			$tr.querySelectorAll('td').forEach(($td) => {
				fields.push($td.textContent.trim().toUpperCase())
			})
			rowData.push({
				$tr,
				fields
			})

		})

		const filter = (val) => {
			val = val.toUpperCase()
			let anyMatch = false
			rowData.forEach((row) => {
				row.$tr.classList.add('hide')
				for (let i = 0; i < row.fields.length; i++) {
					const isMatch = row.fields[i].indexOf(val) > -1
					if (isMatch) {
						row.$tr.classList.remove('hide')
						$tbody.prepend(row.$tr)
						anyMatch = true
						break
					}
				}
			})
			$table.classList.toggle('empty', !anyMatch)
		}

		const reset = () => {
			rowData.forEach((row) => {
				row.$tr.classList.remove('hide')
			})
			$table.classList.remove('empty')
		}

		$input.addEventListener("input", (e) => {
			const val = $input.value
			val.length > 1 ? filter(val) : reset()
		})

		$input.addEventListener('keydown', (e) => {
			if (e.key === "Escape") {
				$input.value = ''
				$input.blur()
				reset()
			}
		});

	}

	return {
		init: init
	};
})();
